import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as param_ from 'jquery-param';
import { Observable } from 'rxjs';
import { IFacebookPostBody, IFacebookRequestParams } from '../shared.type';
const param = param_;

@Injectable()
export class FacebookService {
  private URL = `https://fb.aitarget.com/api/facebook`;

  constructor(private http: HttpClient) {}

  public get(params: IFacebookRequestParams): Observable<any> {
    return this.http.get(this.URL, {
      params: new HttpParams({ fromString: param(params) })
    });
  }

  public post(body: IFacebookPostBody): any {
    return this.http.post(this.URL, body);
  }
}
